
var YTdeferred = jQuery.Deferred();

window.onYouTubeIframeAPIReady = function () {
	YTdeferred.resolve(window.YT);
};

(function ($) {
	$.ajaxSetup({
		cache: true
	});

	$.getScript("https://www.youtube.com/iframe_api")
		.done(function (script, textStatus) {
		});

	$.fn.simplePlayer = function () {
		var video = $(this);
		var play = $('<div />', { id: 'play' }).hide();
		var defaults = {
			autoplay: 1,
			autohide: 1,
			border: 0,
			wmode: 'opaque',
			enablejsapi: 1,
			modestbranding: 1,
			version: 3,
			hl: 'en_US',
			rel: 0,
			showinfo: 0,
			hd: 1,
			iv_load_policy: 3 // add origin
		};

		// onYouTubeIframeAPIReady

		YTdeferred.done(function (YT) {
			play.appendTo(video).fadeIn('slow');
		});

		function onPlayerStateChange(event) {
			if (event.data == YT.PlayerState.ENDED) {
				play.fadeIn(500);
			}
		}

		function onPlayerReady(event) {
			// var replay = document.getElementById('play');
			// replay.addEventListener('click', function () {
			// 	player.playVideo();
			// });
			event.target.playVideo();
		}

		play.bind('click', function () {
			if (!$('#player').length) {
				$(`<iframe src="https://www.youtube-nocookie.com/embed/${video.data('video')}?autoplay=1&rel=0&iv_load_policy=3&fs=0&controls=0&disablekb=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" id="player" width="${video.width()}" height="${video.height()}" seamless="seamless" title="The Better India" frameborder="0"></iframe>`)
					.css('border', 'none')
					.appendTo(video);

				video.children('img').hide();
				$(this).css('background-image', 'url(play-button.png), url(' + video.children().attr('src') + ')').hide();

				player = new YT.Player('player', {
					playerVars: { 'autoplay': 1, 'controls': 0, 'showinfo': 0 },
					events: { 'onStateChange': onPlayerStateChange, 'onReady': onPlayerReady }
				}
				);
			}
			$(this).hide();
		});
		return this;
	};
}(jQuery));

jQuery("#featured_video").simplePlayer();

setTimeout(() => {

	if (jQuery("#featured_video #play").length == 0) {
		jQuery("#featured_video").simplePlayer();
	}

}, 1000);




let articleAjax = {
	isEmail(email) {
		var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		return email.match(mailformat) ? true : false;
	},
	phonenumber(inputtxt) {
		var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
		if (inputtxt.match(phoneno)) {
			return true;
		}
		else {
			return false;
		}
	},

	postFeel() {
		/**
		 * Subscribe to Our postLike
		 */
		if (jQuery('[data-element="vspl_reaction"]').length > 0) {
			jQuery(document).on(
				"click",
				'[data-element="vspl_reaction"]',
				function (e) {
					e.preventDefault();
					e.stopImmediatePropagation();
					e.stopPropagation();
					jQuery('[data-element="feedbackform"]').hide();
					let reaction = jQuery(this).data("value");
					let parent = jQuery(this).parent(".vspl__reactions");
					let clientID = dataLayersWP.el.clientID;
					let formData = jQuery("#vspl__feedback--form").serializeArray();

					jQuery(this).siblings("li").removeClass("active");
					jQuery(this).addClass("active");

					if (!!reaction !== false && reaction != 'dosomething' && reaction != 'liked') {
						jQuery.ajax({
							url: vspl.ajaxurl,
							type: "post",
							data: {
								action: "vspl__post_feel",
								security: vspl.security,
								pid: vspl.pid,
								reaction: reaction,
								clientid: clientID,
								formdata: formData,
							},
							success(data) {
								parent.addClass("triggered");
								dataLayersWP.postReactions({
									'name': reaction,
									'position': jQuery('.vspl__reactions li.active').data('position')
								});
								articleAjax.postFeelCount();

							},
						});
					} else if (reaction == 'dosomething' || reaction == 'liked') {
						jQuery('[data-element="feedbackform"]').show();
						if (jQuery("#vspl__feedback--form").length > 0) {
							jQuery(document).on("click", '[data-feedback="submit"]', function (e) {
								e.preventDefault();

								let formData = jQuery("#vspl__feedback--form").serializeArray();

								jQuery(".vspl__contact--field").removeClass("vspl__error");

								let txtName = jQuery.trim(
									jQuery("#vspl__feedback--form #txtname").val()
								);
								let txtEmail = jQuery.trim(
									jQuery("#vspl__feedback--form #txtemail").val()
								);
								let txtMessage = jQuery.trim(
									jQuery("#vspl__feedback--form #txtmessage").val()
								);

								let isValid = true;

								if (txtName.length < 3) {
									isValid = false;
									jQuery("#vspl__feedback--form #txtname").addClass("vspl__error");
								}

								if (articleAjax.isEmail(txtEmail) == false) {
									isValid = false;
									jQuery("#vspl__feedback--form #txtemail").addClass("vspl__error");
								}


								if (txtMessage.length < 10) {
									isValid = false;
									jQuery("#vspl__feedback--form #txtmessage").addClass("vspl__error");
								}

								if (isValid == true) {
									jQuery.ajax({
										url: vspl.ajaxurl,
										type: "post",
										data: {
											action: "vspl__post_feel",
											security: vspl.security,
											pid: vspl.pid,
											reaction: reaction,
											clientid: clientID,
											formdata: formData,
										},
										success(data) {
											parent.addClass("triggered");
											jQuery('[data-element="feedbackform"]').hide();
											dataLayersWP.postReactions({
												'name': reaction,
												'position': jQuery('.vspl__reactions li.active').data('position')
											});
											articleAjax.postFeelCount();
											jQuery('[data-element="feedbackform"]').hide();
										},
									});
								} else {
									return false;
								}
							});
						}
					}
				}
			);
		}
	},
	postFeelCount() {
		jQuery.ajax({
			url: vspl.ajaxurl,
			type: "post",
			data: {
				action: "vspl__post_feel_count",
				security: vspl.security,
				pid: vspl.pid,
			},
			success(data) {
				jQuery('[data-count="inspired"]').text(data.inspired);
				jQuery('[data-count="aware"]').text(data.aware);
				jQuery('[data-count="informed"]').text(data.informed);
				jQuery('[data-count="dosomething"]').text(data.dosomething);
			},
		});
	},
	init() {
		//this.postFeel();
		// setInterval(() => {
		// 	articleAjax.postFeelCount();
		// }, 20000);
	},
};


let community = {
	el: {
		validate: false,
		activityID: 0,
		apibase: 'https://community.thebetterindia.com'
	},
	start() {
		this.el.activityID = 0;
	}
};

jQuery(window).load(function () {
	//articleAjax.postFeelCount();
	articleAjax.init();
	community.start();
})